module.exports = __webpack_public_path__ + "img/oly.f1623a10.png";